import { z } from "zod";

/** Frontend Environment Variables
 *
 * Variables marked with `NX_PUBLIC_` will have their values from `process.env` injected at build-time.
 *
 * - The frontend doesn't have a concept of runtime `process.env`, so non `NX_PUBLIC_` variables will be
 * lost after build. _`NODE_ENV` is a special case, injected in frontend builds even without the
 * `NX_PUBLIC_` prefix._
 *
 * - Prefer adding values to [config.ts](../config/config.ts) over this file. Use `process.env` when
 * the value must come from the environment (e.g. CI-injected dynamic URLs, git sha).
 *
 * 🚨 **IMPORTANT** 🚨 Never prefix sensitive values with `NX_PUBLIC_`, as they will be exposed in the bundle.
 * If you need sensitive values in the frontend, keep them unprefixed and ensure they're only used in build
 * logic or fetch them securely at runtime from a secrets management solution.
 */
export const env = z
  .object({
    NODE_ENV: z.union([
      z.literal("development"),
      z.literal("production"),
      z.literal("test"),
    ]),
    NX_PUBLIC_CORE_BACKEND_URL: z
      .string()
      .optional()
      .refine((val) => !val?.endsWith("/") && !val?.endsWith("/graphql"), {
        message: "Core backend URL should not end with '/' or '/graphql'",
      }),
    NX_PUBLIC_ASSETS_URL: z
      .string()
      .optional()
      .refine((val) => !val?.endsWith("/"), {
        message: "Assets URL should not end with '/'",
      }),
    NX_PUBLIC_REMOTE_BASE_HOST: z.string().min(1).optional(),
    NX_PUBLIC_SSO_FRONTEND_URL: z.string().optional(),
    NX_PUBLIC_COMMIT: z.string(),
  })
  .parse({ NODE_ENV: process.env.NODE_ENV, ...process.env });
